export const LANDING_PAGE_ROUTE = '/login';

export const SPARKRX_PDT_UID = '8dpNPSmSnyN3vxeBi4RtM9';
export const SLEEPIO_PDT_UID = 'BxgXBrgwswcX58wFNwhVfv';
export const DAYLIGHT_PDT_UID = 'DhZzR9fNJyNGMETp6Qgr6K';
export const DAYLIGHT_PLATGEN_PDT_UID = 'WcLGEey8ZMtnpoKBDrWH26';

// https://www.oreilly.com/library/view/regular-expressions-cookbook/9781449327453/ch04s01.html
// eslint-disable-next-line
export const EMAIL_VALIDATION_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;

// RTX's internal authentication alias domain — can't receive mail.
// Only supports one domain today; can be extended to a list later if needed.
export const BLOCKED_SIGNUP_EMAIL_DOMAIN = 'adxuser.com';

// https://ihateregex.io/expr/phone/
export const PHONE_VALIDATION_REGEX = /^[+]?\(?\d{3}\)?[-\s.]?\d{3}[-\s.]?\d{4,6}$/i;

// Validates this format: MM/DD/YYYY
export const DOB_VALIDATION_REGEX = /(?:(09|04|06|11)(\/)(0[1-9]|[12]\d|30)(\/)((?:19|20)\d\d))|(?:(01|03|05|07|08|10|12)(\/)(0[1-9]|[12]\d|3[01])(\/)((?:19|20)\d\d))|(?:02(\/)(?:(?:(0[1-9]|1\d|2[0-8])(\/)((?:19|20)\d\d))|(?:(29)(\/)((?:(?:19|20)(?:04|08|12|16|20|24|28|32|36|40|44|48|52|56|60|64|68|72|76|80|84|88|92|96))|2000))))/; // eslint-disable-line

// Validates zipcodes in these formats: #####
export const ZIPCODE_VALIDATION_REGEX = /^(\d{5})$/;

/* Validates password with these rules:
 - 8-24 characters
 - Include letters, numbers, and special characters
 */
export const PASSWORD_VALIDATION_REGEX = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,24}$/;

export const EN = 'EN';
export const ES = 'ES';

export const LANGUAGE_LIST = [
  { value: EN, label: 'English' },
  { value: ES, label: 'Español' },
];

export const MINIMUM_BIRTH_YEAR = 1900;

export const SINGULAR_SDK_KEY = 'bighealth_8b9fd55c';
export const SINGULAR_SDK_SECRET = 'c65265155b6d1a8de24c00a5570aad38';

export const EMPLOYER_ORG_SLUG_KEY = 'employer_org_slug';
export const REDIRECT_TO_SESSION_KEY = 'cap_redirect_to';

// Deep-link targets used by Canopy to re-open the app after authentication.
// Sign-up lands on authCallback (owns the magic-link browser session for ASWebAuthenticationSession).
// Login uses exchange-callback (dedicated token-only session handoff screen).
export const CANOPY_SIGN_UP_CALLBACK = 'sleep-companion://authCallback';
export const CANOPY_LOGIN_CALLBACK = 'sleep-companion://exchange-callback';

/**
 * Stand-in for the `:org_slug` segment on the Sleepio login route.
 *
 * A login magic link carries no organisation — vercel-auth-functions builds that URL and
 * has none to put in it — but the route pattern requires the segment, and an empty one
 * leaves a `//` that matches nothing. The login path never reads the value, so any
 * non-empty string works; this is named so it can be grepped and so a Cortex-facing call
 * can assert it never receives it.
 *
 * **The value must match what the Canopy app sends.** The app's Login button builds this
 * same URL from its own hardcoded constant — `SLEEPIO_CORTEX_ORGANIZATION_SLUG` in
 * `canopy/packages/app/constants/cortex.ts` — so a member arriving from the app carries
 * that slug, not one chosen here. When the two disagreed, the "is there a real
 * organisation?" test below recognised only this side's value and let an app-initiated
 * sign-in start a coverage check against a stand-in. One value, both sides.
 *
 * Both are temporary. Neither side has a real organisation to put here, and the segment
 * should not exist on a login route at all — see the follow-on noted in the app's own
 * constant ("org context is on the user's account").
 *
 * One known edge, testing-only: this string is also a real organisation slug, so a QA
 * account genuinely enrolled under it reads as having no organisation on the password
 * path. Acceptable while the value is what it is.
 */
export const LOGIN_ORG_SLUG_PLACEHOLDER = 'sleepio-internal-only-testing';
export const ACCESS_CODE_SESSION_KEY = 'cap_access_code';
export const DEPENDENT_ACTIVATION_DATA_KEY = 'dependent_activation_data';

export type LineOfBusiness = 'wellness' | 'rx';

/**
 * Sleepio Activation Flow A/B Experiment
 *
 * - VARIANT_A: LineStep - horizontal progress bar with 3 lines
 * - VARIANT_B: ListStep - numbered list showing steps with durations
 */
export const VARIANT_A = 'variant-a';
export const VARIANT_B = 'variant-b';

export const ONBOARDING_STEPS = [
  { titleKey: 'onboarding.steps.verify_email', durationKey: 'onboarding.steps.duration_30_seconds' },
  { titleKey: 'onboarding.steps.confirm_coverage', durationKey: 'onboarding.steps.duration_1_minute' },
  { titleKey: 'onboarding.steps.download_sleepio', durationKey: 'onboarding.steps.duration_1_minute' },
];
